import { levelApi } from "../api/levelApi";
import type { CatalogLevel1, CatalogLevel2 } from "../types/level.types";

export type { CatalogLevel1, CatalogLevel2 };

export async function getCatalogLevels(): Promise<CatalogLevel1[]> {
  return levelApi.getCatalogLevels();
}

export async function getLevel1ById(id: string) {
  const levels = await getCatalogLevels();
  return levels.find((l) => l.id === id);
}

export async function getLevel2ById(level1Id: string, level2Id: string) {
  const l1 = await getLevel1ById(level1Id);
  return l1?.levels.find((l) => l.id === level2Id);
}

export async function getLevel3LabelById(level3Id: string): Promise<string> {
  const options = await levelApi.getLevel3Options();
  return options.find((o) => o.id === level3Id)?.label ?? level3Id;
}
